<template>
  <div>
    <sys-data-table
      :headers="headers"
      :items="desserts"
      :search="pesquisa"
      :fixed-header="true"
      :height="alturaDaJanela - 150"
      :item-height="45"
    >
      <template #top>
        <div class="d-flex align-center pb-2 pt-3 w-full">
          <v-icon :size="22">mdi-format-list-bulleted</v-icon>
          <span class="font-weight-medium font-19 ml-1 text-no-wrap text-gray-1000">Filiais de separação</span>

          <v-spacer />

          <div class="w-400 mr-2">
            <v-text-field
              v-model="pesquisa"
              append-icon="mdi-magnify"
              label="Pesquisar"
              clearable
              hide-details
              dense
            />
          </div>

          <DialogNovo @atualizar-tela-inicial="buscarListagem()" />
        </div>
      </template>

      <template #item.filial_destino="{ item }">
        <v-chip small>{{ item.filial_destino }}</v-chip>
      </template>

      <template #item.filiais_origem="{ item }">
        <v-chip v-for="(item, key) in item.filiais_origem" :key="key" class="ml-2px" small>
          {{ item }}
        </v-chip>
      </template>

      <template #item.coberturas="{ item }">
        <v-chip v-for="(valor, key) in item.coberturas" :key="key" class="ml-2px" small>
          <Legenda
            :titulo="`Cobertura de Estoque da filial origem ${valor.filial}`"
            :legenda="`${Helpers.formatarValor(valor.cobertura)} dias`"
          >
            {{ Helpers.formatarValor(valor.cobertura) }} dias
          </Legenda>
        </v-chip>
      </template>

      <template #item.tempos_ressuprimento="{ item }">
        <v-chip v-for="(valor, key) in item.tempos_ressuprimento" :key="key" class="ml-2px" small>
          <Legenda
            :titulo="`Tempo de Ressuprimento da filial origem ${valor.filial}`"
            :legenda="`${Helpers.formatarValor(valor.tempo_ressuprimento)} dias`"
          >
            {{ Helpers.formatarValor(valor.tempo_ressuprimento) }} dias
          </Legenda>
        </v-chip>
      </template>

      <template #item.action="{ item }">
        <DialogEditar :item="item" @atualizar-tela-inicial="buscarListagem()" />
        <DialogDeletar :item="item" @atualizar-tela-inicial="buscarListagem()" />
      </template>
    </sys-data-table>
  </div>
</template>

<script>
import DialogNovo from "./DialogNovo.vue";
import DialogEditar from "./DialogEditar.vue";
import DialogDeletar from "./DialogDeletar.vue";
import Responsividade from "@/helpers/ResponsiveHeight";
import { getMapaSeparacao } from './Requisicoes';
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import {logout} from "@/helpers";

export default {
  components: {
    Legenda,
    DialogNovo,
    DialogEditar,
    DialogDeletar
  },
  mixins: [Responsividade],
  data: () => ({
    headers: [
      { text: "Grupo de Separação", value: "descricao_grupo" },
      { text: "Filial Destino", value: "filial_destino" },
      { text: "Filiais Origem", value: "filiais_origem" },
      { text: "Cobertura de Estoque", value: "coberturas" },
      { text: "Tempo de Ressuprimento", value: "tempos_ressuprimento" },
      {
        text: "Ações",
        value: "action",
        sortable: false,
        width: "50px",
        align: "right",
      },
    ],
    desserts: [],
    pesquisa: ''
  }),
  created() {
    this.buscarListagem();
  },
  methods: {
    buscarListagem() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getMapaSeparacao()
          .then(listagem => this.desserts = listagem)
          .catch(logout)
      );
    }
  }
}
</script>

<style>

</style>
